import React, { useState } from 'react';
import { AgencyNav } from '../components/agency/AgencyNav';
import { PropertyBrowser } from '../components/agency/PropertyBrowser';
import { BookingBuilder } from '../components/agency/BookingBuilder';
import { MyBookings } from '../components/agency/MyBookings';
type ViewType = 'browse' | 'booking' | 'mybookings';
export function AgencyPortal() {
  const [activeView, setActiveView] = useState<ViewType>('browse');
  const [selectedProperty, setSelectedProperty] = useState<string | null>(null);
  const handleSelectProperty = (propertyId: string) => {
    setSelectedProperty(propertyId);
    setActiveView('booking');
  };
  const handleBackToBrowse = () => {
    setSelectedProperty(null);
    setActiveView('browse');
  };
  const renderContent = () => {
    switch (activeView) {
      case 'browse':
        return <PropertyBrowser onSelectProperty={handleSelectProperty} data-id="element-1265" />;
      case 'booking':
        if (selectedProperty) {
          return <BookingBuilder propertyId={selectedProperty} onBack={handleBackToBrowse} data-id="element-1266" />;
        }
        return <PropertyBrowser onSelectProperty={handleSelectProperty} data-id="element-1267" />;
      case 'mybookings':
        return <MyBookings data-id="element-1268" />;
      default:
        return <PropertyBrowser onSelectProperty={handleSelectProperty} data-id="element-1269" />;
    }
  };
  return <div className="min-h-screen bg-stone-50 font-sans text-stone-900 selection:bg-red-600/20" data-id="element-1270">
      <AgencyNav activeView={activeView} setActiveView={setActiveView} data-id="element-1271" />
      <main className="max-w-7xl mx-auto px-6 pt-12" data-id="element-1272">{renderContent()}</main>
    </div>;
}